<template>
  <div class="container py-4">
    <!-- Breadcrumb -->
    <nav aria-label="breadcrumb" class="mb-4">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link to="/" class="text-decoration-none">Home</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ currentTabTitle }}
        </li>
      </ol>
    </nav>

    <!-- Tab Navigation matching Admin Policies -->
    <div class="theme-tabs mb-4">
      <button 
        class="theme-tab" 
        :class="{ 'theme-tab--active': activeTab === 'privacy' }"
        @click="activeTab = 'privacy'"
        type="button">
        <i class="fas fa-shield-alt me-2"></i>
        Privacy Policy
      </button>
      <button 
        class="theme-tab" 
        :class="{ 'theme-tab--active': activeTab === 'terms' }"
        @click="activeTab = 'terms'"
        type="button">
        <i class="fas fa-file-signature me-2"></i>
        Terms & Conditions
      </button>
    </div>

    <!-- Main Card matching Admin Policies -->
    <div class="card bg-white shadow-sm border-0 rounded-4 overflow-hidden mb-4">
      <div class="card-header bg-white border-0 pt-4 pb-0 px-4">
        <h4 class="fw-bold text-dark mb-1">
          <i :class="activeTab === 'privacy' ? 'fas fa-shield-alt text-primary me-2' : 'fas fa-file-signature text-primary me-2'"></i>
          {{ currentTabTitle }}
        </h4>
        <p class="text-muted small mb-0">
          {{ activeTab === 'privacy' ? 'Official privacy policy for users and members.' : 'Terms and conditions for loyalty program membership.' }}
        </p>
      </div>
      
      <div class="card-body px-4 pb-4 pt-3">
        <div v-if="activeTab === 'privacy'">
          <PublicPolicyDisplay type="privacy" />
        </div>
        <div v-if="activeTab === 'terms'">
          <PublicPolicyDisplay type="terms" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PublicPolicyDisplay from '@/components/PublicPolicyDisplay.vue';

export default {
  name: 'PublicPoliciesPage',
  components: {
    PublicPolicyDisplay
  },
  data() {
    return {
      activeTab: 'privacy'
    }
  },
  computed: {
    currentTabTitle() {
      return this.activeTab === 'privacy' ? 'Privacy Policy' : 'Terms & Conditions';
    }
  },
  mounted() {
    // Set initial tab based on route query parameter
    const tab = this.$route.query.tab;
    if (tab && ['privacy', 'terms'].includes(tab)) {
      this.activeTab = tab;
    }
  },
  watch: {
    activeTab(newTab) {
      // Update URL query parameter when tab changes
      if (this.$route.query.tab !== newTab) {
        this.$router.replace({ 
          ...this.$route, 
          query: { ...this.$route.query, tab: newTab }
        });
      }
    }
  }
}
</script>

<style scoped>
.theme-tabs {
  display: flex;
  gap: 4px;
  background: #F5F6FA;
  padding: 4px;
  border-radius: 12px;
  width: fit-content;
}

.theme-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #717784;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.theme-tab:hover {
  color: #737f96;
}

.theme-tab--active {
  background: #FFFFFF;
  color: var(--primary-color, #F93E3E);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-weight: 600;
}

.card {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border: none;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: ">";
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  
  .theme-tabs {
    width: 100%;
  }

  .theme-tab {
    flex: 1;
    justify-content: center;
    padding: 8px 12px;
    font-size: 13px;
  }
}
</style>